export default {"src":"/trader-new/_next/static/media/SetttingsIcon.76f26ee8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};